<ng-template #popContent class="connection-warning-popover">
    <fa-icon [icon]="faExclamationCircle" size="2x" />
    <div jhiTranslate="artemisApp.disconnectedAlert"></div>
    <jhi-close-circle (click)="popover.close()" />
</ng-template>
<div
    class="connection-warning"
    [ngClass]="{ disconnected: disconnected() }"
    [ngbPopover]="popContent"
    popoverClass="connection-warning-popover"
    #popover="ngbPopover"
    [triggers]="'manual'"
    [placement]="'auto'"
    [autoClose]="false"
    (click)="togglePopover()"
    #keyboardAction6
    role="button"
    tabindex="0"
    [attr.aria-expanded]="popover.isOpen()"
    [attr.aria-label]="(disconnected() ? 'connectionStatus.disconnected' : 'connectionStatus.connected') | artemisTranslate"
    (keydown.enter)="$event.target === $event.currentTarget ? keyboardAction6.click() : undefined"
    (keydown.space)="$event.target === $event.currentTarget ? $event.preventDefault() : undefined"
    (keyup.space)="$event.target === $event.currentTarget ? keyboardAction6.click() : undefined"
>
    <fa-icon [icon]="faWifi" />
    @if (disconnected() && !isOnExamParticipationPage()) {
        <fa-icon id="pulse-icon" [icon]="faWifi" />
    }
</div>
